export type Role = (typeof Role)[keyof typeof Role];

export const Role = {
  CUSTOMER: 'ot-customer',
  GUEST: 'ot-guest',
  INTERNAL: 'ot-internal',
  PLAYER: 'ot-player',
  ROOT: '',
  SUPPORT: 'ot-support',
} as const;

/**
 * Check if the input string matches any value of the `Role` object.
 *
 * @param input - The input string to be checked.
 * @returns `true` if the input matches a `Role` value, `false` otherwise.
 */
export const isRole = (input: string): input is Role => {
  return Object.values(Role).includes(input as Role);
};
